export default __webpack_public_path__ + "static/media/solely_header.115a7291.jpg";